<template>
  <div class="page-box">
    <div
      class="big-menu-box"
      style="width: 212px; background-color: #fff; flex-shrink: 0"
    >
      <div
        class="left-menu-box"
        id="left-menu-box"
        :style="{ height: left_book_height + 'px' }"
      >
        <div style="margin-bottom: 10px">
          <a-input-search
            placeholder="搜索公众号"
            style="width: 180px"
            @search="searchGzhInput($event, 'search_button')"
          />
        </div>

        <div v-for="(item, index) in menuData" :key="index">
          <div
            class="left-label"
            @click="changeMenu(item)"
            :style="{ color: item.style_status ? '#1d99ff' : '' }"
          >
            <span style="user-select: none">{{ item.name }}</span>

            <svg
              v-if="item.select_status && item.select_loading != 1"
              style="transform: rotate(180deg)"
              t="1666774062192"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2617"
              width="12"
              height="12"
            >
              <path
                d="M512 714.666667c-8.533333 0-17.066667-2.133333-23.466667-8.533334l-341.333333-341.333333c-12.8-12.8-12.8-32 0-44.8 12.8-12.8 32-12.8 44.8 0l320 317.866667 317.866667-320c12.8-12.8 32-12.8 44.8 0 12.8 12.8 12.8 32 0 44.8L533.333333 704c-4.266667 8.533333-12.8 10.666667-21.333333 10.666667z"
                p-id="2618"
                fill="#86909c"
              ></path>
            </svg>
            <svg
              v-else-if="!item.select_status && item.select_loading != 1"
              t="1666774062192"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2617"
              width="12"
              height="12"
            >
              <path
                d="M512 714.666667c-8.533333 0-17.066667-2.133333-23.466667-8.533334l-341.333333-341.333333c-12.8-12.8-12.8-32 0-44.8 12.8-12.8 32-12.8 44.8 0l320 317.866667 317.866667-320c12.8-12.8 32-12.8 44.8 0 12.8 12.8 12.8 32 0 44.8L533.333333 704c-4.266667 8.533333-12.8 10.666667-21.333333 10.666667z"
                p-id="2618"
                fill="#86909c"
              ></path>
            </svg>
            <a-icon v-if="item.select_loading == 1" type="loading" />
          </div>

          <template v-if="item.select_status">
            <template v-for="(value, key) in item.value">
              <div
                v-if="item.name != '未分组'"
                style="
                  padding-left: 20px;
                  color: #999;
                  height: 40px;
                  line-height: 40px;
                  user-select: none;
                "
              >
                {{ key }}
              </div>
              <div
                v-for="(item_z, index_z) in value"
                :class="[item_z.click_status ? 'left-children-cell-true' : '']"
                @click="menuSecond(item_z, item)"
                class="left-children-cell"
                :id="item.key + '_' + item_z.id"
              >
                {{ item_z.gzh_name }}
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
    <div class="right_div_box">
      <div class="top_div">
        <div
          class="top_info_div"
          v-if="gzhShowTab.length < 2 || type_value != 1"
          style="user-select: none; margin-bottom: 16px"
        >
          <div
            class="top_info_div"
            style="
              font-size: 16px;
              font-weight: 600;
              user-select: none;
              margin-right: 10px;
            "
          >
            {{ title_gzh_name || "请先选择公众号" }}
          </div>
          <div v-if="title_gzh_name" class="top_info_div">
            <!-- <a-button disabled>{{ r_content_type | formatText }}</a-button> -->
            <!-- <div class="text_div_type">{{ r_content_type | formatText }}</div> -->
            <a-button type="text" @click="changeType">{{
              r_content_type | formatText
            }}</a-button>
            <a-popover
              title="运营内容模式，决定菜单设置、各类客服消息的内容。3个选项:"
            >
              <template slot="content">
                <p class="title_text">H5站：全部用户H5站</p>
                <p class="title_text">H5站+小程序：新用户小程序，老用户H5站</p>
                <p class="title_text">小程序：全部用户小程序</p>
              </template>
              <a-icon
                type="question-circle"
                style="cursor: pointer; margin-left: 6px"
              />
            </a-popover>
          </div>
        </div>
        <template v-else>
          <a-tabs @change="changeTab" style="margin-top: -5px">
            <a-tab-pane
              v-for="item in gzhShowTab"
              :key="item.id"
              :tab="item.gzh_name"
            >
            </a-tab-pane>
          </a-tabs>
        </template>
        <div style="margin: 0 0 20px" v-if="r_gzh_id">
          <a-radio-group v-model="type_value" @change="onChangeA">
            <a-radio-button :value="5" style="margin-right: 15px">
              模板设置
            </a-radio-button>
            <a-radio-button :value="1"> 菜单管理 </a-radio-button>
            <a-radio-button :value="2"> 关注后回复 </a-radio-button>
            <a-radio-button :value="3"> 关键词回复 </a-radio-button>
            <a-radio-button :value="4"> 延迟客服消息 </a-radio-button>
          </a-radio-group>
        </div>
      </div>
      <div class="mid_div" v-if="r_gzh_id">
        <p class="div_title_text" v-if="type_value != 5">H5站</p>
        <div class="content_box" v-if="type_value == 1">
          <pageGzhMenu
            key="h5_getGzhMenu"
            ref="getGzhMenu"
            :r_gzh_id="r_gzh_id"
            @select-sync-gzh="selectSyncGzh"
            set_type="h5"
            page_type="config-template1"
            @menu-handle="h5MenuHandle"
          ></pageGzhMenu>
        </div>

        <div class="content_box" v-if="type_value == 2">
          <pageFollowReply
            key="h5_getFollowReply"
            ref="getFollowReply"
            set_type="h5"
          ></pageFollowReply>
        </div>

        <!-- 关键词回复  已完成 -->
        <div class="content_box" v-if="type_value == 3">
          <pageKeywordReply
            key="h5_getKeywordReply"
            ref="getKeywordReply"
            set_type="h5"
          ></pageKeywordReply>
        </div>
        <div class="content_box" v-if="type_value == 4">
          <pageContactMsg
            key="h5_getContactMsg"
            ref="getContactMsg"
            set_type="h5"
          ></pageContactMsg>
        </div>
        <div class="content_box" v-if="type_value == 5">
          <pageSetTemplate
            key="h5_getSetTemplate"
            ref="getSetTemplate"
          ></pageSetTemplate>
        </div>
      </div>
      <div class="bottom_div" v-if="type_value != 5">
        <p class="div_title_text">小程序</p>
        <div class="content_box" v-if="type_value == 1">
          <pageGzhMenu
            key="mini_miniGetGzhMenu"
            ref="miniGetGzhMenu"
            :r_gzh_id="r_gzh_id"
            @select-sync-gzh="selectSyncGzh"
            set_type="mini"
            page_type="config-template1"
            @menu-handle="miniMenuHandle"
          ></pageGzhMenu>
        </div>
        <div class="content_box" v-if="type_value == 2">
          <pageFollowReply
            key="mini_miniGetFollowReply"
            ref="miniGetFollowReply"
            set_type="mini"
          ></pageFollowReply>
        </div>
        <div class="content_box" v-if="type_value == 3">
          <pageKeywordReply
            key="mini_miniGetKeywordReply"
            ref="miniGetKeywordReply"
            set_type="mini"
          ></pageKeywordReply>
        </div>
        <div class="content_box" v-if="type_value == 4">
          <pageContactMsg
            key="mini_miniGetContactMsg"
            ref="miniGetContactMsg"
            set_type="mini"
          ></pageContactMsg>
        </div>
      </div>
      <div class="empty_div" v-if="type_value == 1"></div>
      <div class="bottom_save_mune_div" v-if="type_value == 1">
        <a-button
          @click="sendButton"
          style="margin-right: 30px; margin-left: 17px; margin-top: 20px"
          type="primary"
          :loading="saveBtnLoading"
          >保存并发布</a-button
        >
      </div>
      <div
        v-if="type_value != 5 && type_value != 1"
        style="width: 100%; height: 20px"
      ></div>
    </div>

    <div class="loading-box" v-if="search_button_loading">
      <a-spin size="large" />
    </div>
    <a-modal
      v-model="open"
      title="编辑运营内容模式"
      @ok="okClick"
      @cancel="cancelClick"
      style="top: 200px"
    >
      <div class="open_div">
        <span class="open_span">运营内容模式:</span>
        <a-select
          v-model="contentType"
          placeholder="请选择运营内容模式"
          style="width: 200px"
        >
          <a-select-option :value="1">H5</a-select-option>
          <a-select-option :value="2">H5+小程序</a-select-option>
          <a-select-option :value="3">小程序</a-select-option>
        </a-select>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  opeGzhSelect,
  getChannelGzh,
  gzhMenuAdd,
  setContentType,
} from "@/request/api";
import pageGzhMenu from "./components/pageGzhMenu";
import pageFollowReply from "./components/pageFollowReply";
import pageKeywordReply from "./components/pageKeywordReply";
import pageContactMsg from "./components/pageContactMsg";
import pageSetTemplate from "./components/pageSetTemplate";
export default {
  name: "menuManagement_",
  components: {
    pageGzhMenu,
    pageFollowReply,
    pageKeywordReply,
    pageContactMsg,
    pageSetTemplate,
  },
  filters: {
    formatText(val) {
      if (!val) {
        return `未设置`;
      }
      // // 运营内容模式1=h5,2=h5+小程序，3=小程序
      if (!val) {
        return "未设置";
      }
      const typeMap = {
        1: "H5",
        2: "H5+小程序",
        3: "小程序",
      };
      return typeMap[val] || "未设置";
    },
  },
  data() {
    return {
      saveBtnLoading: false,
      open: false,
      contentType: undefined,
      menuData: [], // 左侧渠道数据
      menuDataSave: [], // 左侧渠道数据-保存一份，用于搜索
      left_book_height: 300, // 左边书城列表的高度
      all_style_status: true, // 全部公众号控制
      all_select_control: true, // 全部选项的控制，true为显示

      search_button_loading: false,

      type_value: 5,

      contentData: [],
      content_index_select: 0, // 当前选中的第几个菜单

      title_gzh_name: "", // 当前选择的公众号名字
      r_gzh_id: null, // 当前选择的公众号ID

      gzhTab: [],
      gzhShowTab: [], // 当选择了多个公众号时，存放的数据

      channel_id: "", // 渠道ID
      channel_name: "", // 渠道名字
      channelItem: {},

      rout_c_id: "", // 跳过来路由的渠道ID
      rout_g_id: "", // 跳过来路由的公众号ID
      rout_scroll_control: true, // 侧边滚动条控制
      h5Flag: false,
      h5Data: {},
      r_content_type: undefined,
      
    };
  },
  mounted() {
    let that = this;

    // console.log("document.body.clientHeight",document.body.clientHeight);
    that.left_book_height = document.body.clientHeight - 65 - 20 - 30 - 20;
    if (that.$route.query.c_id) {
      that.rout_c_id = that.$route.query.c_id;
    }
    if (that.$route.query.g_id) {
      that.rout_g_id = that.$route.query.g_id;
    }
    // menuManagement
    // 获取 左侧渠道>公众号
    that.onSearchGzh(null);
  },
  methods: {
    // contentTypeChange() {
    //   this.okClick();
    // },
    async okClick() {
      try {
        const result = await setContentType({
          id: [this.r_gzh_id],
          content_type: this.contentType,
        });
        if (result.data.code === 0) {
          this.$message.success("修改成功");
          this.r_content_type = this.contentType;
          const temp = JSON.parse(JSON.stringify(this.menuData));
          const item = temp.find((item) => item.key === this.channel_id);
          if (item && item.value) {
            for (const key in item.value) {
              const _list = item.value[key];
              const _item = _list.find((itemy) => itemy.id === this.r_gzh_id);
              if (_item) {
                _item.gzh_content_type = this.contentType;
              }
            }
          }
          this.menuData = JSON.parse(JSON.stringify(temp));
          this.open = false;
          this.contentType = undefined;
          this.$refs.getSetTemplate.getInfo(this.r_gzh_id);
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancelClick() {
      this.open = false;
      this.contentType = undefined;
    },
    changeType() {
      this.contentType = this.r_content_type;
      this.open = true;
    },
    async sendButton() {
      const h5Data = await this.$refs.getGzhMenu.getMuneData();
      const miniData = await this.$refs.miniGetGzhMenu.getMuneData();
      let menu1 = {},
        menu2 = {};
      if (h5Data.length > 0) {
        menu1.button = h5Data;
      }
      if (miniData.length > 0) {
        menu2.button = miniData;
      }
      if (this.saveBtnLoading) {
        return;
      }
      this.saveBtnLoading = true;
      gzhMenuAdd({
        gzh_id: this.r_gzh_id,
        menu_list: {
          1: {
            menu: menu1,
          },
          2: {
            menu: menu2,
          },
        },
      })
        .then((res) => {
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            this.$message.success(
              `公众号：${this.title_gzh_name} 菜单保存并发布成功`
            );
          } else {
            this.$message.error(`错误：${res.data.msg}`);
          }
          this.saveBtnLoading = false;
        })
        .catch(() => {
          this.saveBtnLoading = false;
        });
    },
    h5MenuHandle(data) {
      this.h5Data = data;
      this.h5Flag = true;
    },
    async miniMenuHandle(data) {
      if (this.h5Flag) {
        await this.createMune(this.h5Data, "h5");
        await this.createMune(data, "mini");
      }
    },
    createMune(data, type) {
      gzhMenuAdd({
        gzh_id: this.r_gzh_id,
        menu: {
          button: data,
        },
        content_type: type === "h5" ? 1 : 2,
      }).then((res) => {
        // console.log("保存并发布",res);

        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          this.$message.success(`公众号：${this.gzh_name} 菜单 保存并发布成功`);
        } else {
          this.$message.error(`错误：${res.data.msg}`);
        }
      });
    },
    onSearchGzh(e, type) {
      // console.log("公众号搜索",e);
      let that = this;
      that.search_button_loading = true;
      opeGzhSelect().then((res) => {
        // console.log("获取渠道、管理员选择",res);
        if (
          res.data.code == 0 ||
          res.data.code == 200 ||
          res.data.code == 8011
        ) {
          // that.searchSelect = res.data.data
          let channel_data = res.data.data.channel;
          // console.log("channel_data",channel_data);
          let c_key = Object.keys(channel_data);

          let c_data = [];

          for (let key in channel_data) {
            let ooo = {};

            ooo.name = channel_data[key];
            ooo.key = key;
            ooo.select_status = false; // 控制是否展开
            ooo.style_status = false; // 用于控制样式的
            // 0还没加载过，1加载中，2已经加载过
            ooo.select_loading = 0; // 用于判断是否显示加载状态的，第一次获取渠道下的内容需要去请求
            ooo.value = {};

            c_data.push(ooo);
          }
          let a_bj = {
            name: "未分组",
            key: "0",
            select_status: false,
            style_status: false,
            select_loading: 0,
            value: {},
          };
          c_data.push(a_bj);

          // console.log("menuData", c_data);
          that.menuData = c_data;
          that.menuDataSave = c_data;
          that.search_button_loading = false;
          // })

          // 从其他页面跳过来，带了参数就加载对应的渠道
          if (that.rout_c_id && that.rout_g_id) {
            c_data.forEach((res) => {
              if (res.key == that.rout_c_id) {
                that.changeMenu(res);
              }
            });
          }
        } else {
          that.search_button_loading = false;
          if (res.data.code == 401) {
            // 未登录
            localStorage.removeItem("access_token");
            that.$router.replace({
              name: "login",
              params: { type: "not_log" },
            });
          } else {
            that.$message.error(`错误：${res.data.msg}`);
          }
        }
      });
    },
    // 切换书城列表
    changeMenu(e) {
      let that = this;
      if (e.select_loading == 0) {
        e.select_loading = 1;

        getChannelGzh({
          channel_id: e.key,
        }).then((res) => {
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            // console.log("新公众号分组",res.data.data.list);
            let data = res.data.data.list[e.name];

            for (let key in data) {
              data[key].forEach((res) => {
                res.click_status = false;
              });
            }

            e.value = data;
            e.select_status = true;
            e.select_loading = 2;

            // 从其他页面跳过来，带了参数，然后就要加载对应的公众号数据
            if (that.rout_c_id && that.rout_g_id) {
              for (let key in data) {
                data[key].forEach((res) => {
                  if (res.id == that.rout_g_id) {
                    console.log("eeee", e);
                    that.menuSecond(res, e);
                  }
                });
              }
            }
          } else {
            e.select_loading = 0;
            that.search_button_loading = false;
            that.$message.error(`错误：${res.data.msg}`);
          }
        });
      } else if (e.select_loading == 2) {
        e.select_status = !e.select_status;
      }
    },
    // 切换二级标题
    menuSecond(item_z, item) {
      // console.log("item",item);
      // console.log("item_z",item_z);

      let that = this;
      that.type_value = 5; // 重置状态

      this.r_gzh_id = item_z.id;
      this.r_content_type = item_z.gzh_content_type;
      that.channel_id = item.key; // 渠道ID
      that.channel_name = item.name; // 渠道名字

      item.style_status = true;

      this.title_gzh_name = item_z.gzh_name;

      // 存数据到tab数组中
      let arr = []; // 避免不同渠道的公众号切换有问题
      let obj = {
        gzh_name: item_z.gzh_name,
        id: item_z.id,
        content: [],
      };
      arr.push(obj);
      this.gzhTab = arr;
      this.gzhShowTab = arr; // 每次切换公众号这里都要重置

      this.menuData.forEach((res) => {
        if (item.key != res.key) {
          res.style_status = false;
        }
        for (let key in res.value) {
          res.value[key].forEach((res) => {
            res.click_status = false;
          });
        }
      });

      item_z.click_status = !item_z.click_status;

      this.all_style_status = false; // 取消全部的勾选状态

      this.channelItem = item;

      this.$nextTick(() => {
        // 获取菜单管理详情
        // this.$refs.getGzhMenu.getInfo(this.r_gzh_id, this.channelItem, this.title_gzh_name)

        // 获取模板设置
        this.$refs.getSetTemplate.getInfo(this.r_gzh_id);

        if (that.rout_c_id && that.rout_g_id && that.rout_scroll_control) {
          that.rout_scroll_control = false;
          // 控制滚动条滑动到指定位置
          let target = document.getElementById(`${item.key}_${item_z.id}`);
          let parent = document.getElementById("left-menu-box");
          parent.scrollTop = target.offsetTop - parent.offsetTop;
        }
      });
    },

    onChangeA(e) {
      // console.log(`checked = ${e.target.value}`);
      this.type_value = e.target.value;
      if (e.target.value == 1) {
        // 获取菜单管理详情
        this.$nextTick(() => {
          this.$refs.getGzhMenu.getInfo(
            this.r_gzh_id,
            this.channelItem,
            this.title_gzh_name
          );
          this.$refs.miniGetGzhMenu.getInfo(
            this.r_gzh_id,
            this.channelItem,
            this.title_gzh_name
          );
        });
      }
      if (e.target.value == 1) {
        this.gzhShowTab = this.gzhTab;
      }
      if (e.target.value == 2 || e.target.value == 3 || e.target.value == 4) {
        let i_obj = {
          gzh_name: this.title_gzh_name,
          id: this.r_gzh_id,
          channel_id: this.channel_id,
          channel_name: this.channel_name,
        };
        // 关注后回复
        if (e.target.value == 2) {
          this.$nextTick(() => {
            this.$refs.getFollowReply.wxTdCz(i_obj);
            this.$refs.miniGetFollowReply.wxTdCz(i_obj);
          });
        } else if (e.target.value == 3) {
          this.$nextTick(() => {
            this.$refs.getKeywordReply.wxTdCz(i_obj);
            this.$refs.miniGetKeywordReply.wxTdCz(i_obj);
          });
        } else if (e.target.value == 4) {
          this.$nextTick(() => {
            this.$refs.getContactMsg.wxTdCz(i_obj);
            this.$refs.miniGetContactMsg.wxTdCz(i_obj);
          });
        }
      } else if (e.target.value == 5) {
        this.$nextTick(() => {
          this.$refs.getSetTemplate.getInfo(this.r_gzh_id);
        });
      }
    },

    // 同步其他公众号选择
    selectSyncGzh(t_data) {
      this.gzhShowTab = this.gzhTab.concat(t_data);
    },

    // 切换公众号tab
    changeTab(e) {
      // console.log(e);
      // console.log("gzhShowTab",this.gzhShowTab);
      let g_name = "";
      this.gzhShowTab.forEach((res) => {
        if (res.id == e) {
          g_name = res.gzh_name;
        }
      });
      // 获取菜单管理详情
      this.$nextTick(() => {
        this.$refs.getGzhMenu.onChangeTab(e, g_name);
        // this.$refs.getGzhMenu.getInfo(this.r_gzh_id, this.channelItem, this.title_gzh_name)
      });
    },

    // 搜索公众号
    searchGzhInput(e, type) {
      let that = this;

      let save_data = JSON.parse(JSON.stringify(that.menuDataSave));
      if (e) {
        // 有搜索内容
        getChannelGzh({
          gzh_name: e,
        }).then((res) => {
          // console.log("搜索公众号",res.data.data.list);
          let f_ata = res.data.data.list;
          let zzz = [];
          for (let key in f_ata) {
            let data = f_ata[key];
            save_data.forEach((res) => {
              if (key == res.name) {
                let flag = false;
                for (let ke_z in data) {
                  if (
                    data[ke_z] &&
                    data[ke_z][0].channel_id === Number(res.key)
                  ) {
                    flag = true;
                  } else {
                    flag = false;
                  }
                  data[ke_z].forEach((res) => {
                    res.click_status = false;
                  });
                }
                res.value = data;

                res.select_status = true;
                res.style_status = false;
                res.select_loading = 2;
                if (flag) {
                  zzz.push(res);
                }
              }
            });
          }
          const _zzz = JSON.parse(JSON.stringify(zzz));
          for (let index = 0; index < _zzz.length; index += 1) {
            const item = _zzz[index];
            if (item.value) {
              for (const key in item.value) {
                if (item.value[key]) {
                  const _item = item.value[key].find(
                    (itemy) => itemy.id === that.r_gzh_id
                  );
                  if (_item) {
                    item.style_status = true; // 一级菜单展开
                    _item.click_status = true; // 公众号选中状态高亮
                  }
                }
              }
            }
          }
          // zzz.forEach((res) => {
          //   for (let key in res.value) {
          //     res.value[key].forEach((re_z) => {
          //       if (re_z.id == that.r_gzh_id) {
          //         res.style_status = true; // 一级菜单展开
          //         re_z.click_status = true; // 公众号选中状态高亮
          //       }
          //     });
          //   }
          // });
          //
          console.log(_zzz);
          that.menuData = JSON.parse(JSON.stringify(_zzz));
        });
      } else {
        // that.r_gzh_id
        // 把备份公众号菜单数据也处理一下，避免空内容搜索，复制会出现高亮公众号跟右侧所选公众号不一致问题
        save_data.forEach((res) => {
          res.style_status = false;
          for (let key in res.value) {
            res.value[key].forEach((res) => {
              res.click_status = false;
            });
          }
        });

        save_data.forEach((res) => {
          for (let key in res.value) {
            res.value[key].forEach((re_z) => {
              if (re_z.id == that.r_gzh_id) {
                res.style_status = true; // 一级菜单展开

                re_z.click_status = true; // 公众号选中状态高亮
              }
            });
          }
        });

        that.menuData = save_data;
      }
    },
  },
};
</script>
<!-- background-color: rgb(240, 242, 245); -->
<style scoped>
.text_div_type {
  background-color: #f5f5f5;
  border-color: #d9d9d9;
  padding: 10px 14px;
  height: 32px;
  font-size: 14px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  color: #000;
}
.top_info_div {
  display: flex;
  align-items: center;
}
.open_div {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.open_span {
  margin-right: 20px;
}
.page-box {
  margin: -20px -30px -30px -30px;
  background-color: rgb(240, 242, 245);
  padding: 20px 30px 30px 20px;
  height: calc(100vh - 65px);
  display: flex;
  overflow: hidden;
}

.big-menu-box {
  padding: 15px 15px 0 15px;
}
.left-menu-box {
  height: 100%;
  overflow-y: overlay;
  margin-right: -15px;
  padding-right: 15px;
}
.left-label {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 0 15px;
  margin-bottom: 3px;
}
.left-label:hover {
  /* color: #1d99ff; */
  background-color: #f2f3f5;
}
.left-children-cell {
  padding-left: 35px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  margin-bottom: 3px;
  user-select: none;
}
.left-children-cell:hover {
  /* color: #1d99ff; */
  background-color: #f2f3f5;
}
.left-children-cell-true {
  color: #1d99ff;
  background-color: #f2f3f5;
}

/* 设置左侧列滚动条开始 */
/* 滚动条整体 */
.left-menu-box::-webkit-scrollbar {
  /* height决定横向scrollbar的高度，width决定纵向滚动条的宽度 */
  /* height:30px; */
  width: 7px;
  /* 默认：滚动条透明底色 */
  background-color: transparent;
}
/* 滚动条滑块 */
.left-menu-box::-webkit-scrollbar-thumb {
  /* 圆角 */
  border-radius: 10px;
  /* 滑块自身颜色 透明 */
  background-color: transparent;
}
/* 当鼠标hover时 */
.big-menu-box:hover .left-menu-box::-webkit-scrollbar {
  /* 底色 */
  /* background-color:#f3f3f3 !important; */
}
.big-menu-box:hover .left-menu-box::-webkit-scrollbar-thumb {
  /* 滑块颜色 */
  background-color: #999 !important;
}
.left-menu-box::-webkit-scrollbar {
  /* display:none; */
  background-color: transparent;
}
/* 设置左侧列滚动条结束 */

.top_div {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px 0 20px 20px;
  margin-right: 10px;
}
.mid_div {
  background-color: #fff;
  border-radius: 10px;
  margin-top: 12px;
  border-radius: 10px;
  padding: 20px 0 20px 20px;
  margin-right: 10px;
}
.bottom_div {
  background-color: #fff;
  border-radius: 10px;
  margin-top: 12px;
  border-radius: 10px;
  padding: 20px 0 20px 20px;
  margin-right: 10px;
}
.right_div_box {
  width: 100%;
  position: relative;
  overflow-y: scroll;
  height: 100%;
  margin-left: 20px;
}
.div_title_text {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 4px;
}
.bottom_save_mune_div {
  background-color: #fff;
  padding-bottom: 20px;
  position: fixed;
  bottom: 10px;
  right: 0;
  width: calc(100% - 250px);
}
.empty_div {
  height: 60px;
}
.page-box :deep(.ant-modal) {
  top: 120px !important;
}

.popover_title {
  font-size: 14px;
}
.title_text {
  position: relative;
  padding-left: 16px;
  margin-bottom: 4px;
}
.title_text::before {
  position: absolute;
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 6px;
  background-color: #1684fc;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
</style>
